import { SvgIcon } from '@material-ui/core'

export default function AdvertisizingIcon(props: any) {
    return (
        <SvgIcon style={{ width: '28px', height: '28px' }} viewBox="0 0 24 24" fill="none" {...props}>
            <defs>
                <linearGradient id="advertising-gradient" x1="0" y1="0" x2="0" y2="24" gradientUnits="userSpaceOnUse">
                    <stop offset="0%" stopColor="white" stopOpacity="1" />
                    <stop offset="100%" stopColor="white" stopOpacity="0.15" />
                </linearGradient>
            </defs>
            <path
                d="M19.8356 16.9065C20.2788 12.647 20.2788 8.35304 19.8356 4.09355C19.697 2.76124 18.1609 2.08636 17.0859 2.88547L12.9822 5.93588C11.6886 6.89745 10.1197 7.4167 8.50791 7.4167H4.67871C4.12643 7.4167 3.67871 7.86441 3.67871 8.4167V12.5834C3.67871 13.1357 4.12643 13.5834 4.67871 13.5834L8.5079 13.5834C10.1197 13.5834 11.6886 14.1026 12.9822 15.0642L17.0859 18.1146C18.1609 18.9137 19.697 18.2388 19.8356 16.9065Z"
                fill="url(#advertising-gradient)"
            />
            <path
                d="M9.09213 15.802C9.14957 15.5776 9.10006 15.3392 8.95799 15.1562C8.81592 14.9731 8.59724 14.8661 8.36556 14.8661L6.36555 14.8661C6.08147 14.8661 5.82177 15.0266 5.69473 15.2806L4.69473 17.2806C4.52396 17.6222 4.63707 18.0375 4.95745 18.2453L7.09142 19.6293C7.29403 19.7607 7.54751 19.7865 7.77244 19.6986C7.99738 19.6107 8.16623 19.4199 8.22611 19.186L9.09213 15.802Z"
                fill="url(#advertising-gradient)"
            />
        </SvgIcon>
    )
}
